import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ModalType } from '~/types';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.modal};
    top: 50%;
    left: 50%;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    min-width: 280px;
    max-width: 314px;
    min-height: 180px;
    overflow: hidden;
    transform: translate(-50%, -50%) translate(-0.5px, -0.5px);
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    backdrop-filter: blur(50px);
    will-change: translate;
  `}
`;

export const Background = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.background};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_5_alpha};
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 8px;
`;

export const TitleBox = styled.div`
  ${({ theme }) => css``}
`;

export const Title = styled.strong`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body18_bold}
    color: ${theme.content.content_light_1};
  `}
`;

export const DescBox = styled.div`
  max-height: 30dvh;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Desc = styled.p`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body16_medium}
    color: ${theme.content.content_light_2};
  `}
`;

export const ButtonWrapper = styled.div<{ type: ModalType }>`
  ${({ theme, type }) => css`
    display: flex;
    justify-content: center;
    height: 56px;
    ${type !== 'single' && `border-top: 1px solid ${theme.stroke.stroke_1}`}
  `}
`;

export const SingleButtonBox = styled.button`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    padding: 0 24px 16px;

    & > button {
      display: block;
      width: 100%;
      height: 100%;
      border: 1px solid ${theme.stroke.stroke_1};
      border-radius: 24px;
      background: ${theme.backgroundColor.bg_light_5_alpha};

      ${theme.fontStyle.text.body18_medium}
      color: ${theme.content.content_light_1};
    }
  `}
`;

export const LeftButtonBox = styled.div<{ type: ModalType }>`
  ${({ theme, type }) => css`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;

    & > button {
      display: block;
      width: 100%;
      height: 100%;
      ${theme.fontStyle.text.body16_medium}
      color: ${type === 'double_red'
        ? theme.content.content_light_1
        : theme.content.content_light_5};
    }
  `}
`;
export const RightButtonBox = styled.div<{ type: ModalType }>`
  ${({ theme, type }) => {
    const colorMap: Partial<Record<ModalType, string>> = {
      double_red: theme.themeColor.negative,
      double_emphasize: theme.content.main_1,
    };

    return css`
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: center;
      border-left: 1px solid ${theme.stroke.stroke_1};

      & > button {
        display: block;
        width: 100%;
        height: 100%;
        ${theme.fontStyle.text.body16_medium}
        color: ${colorMap[type] ?? theme.content.content_light_1};
      }
    `;
  }}
`;
